module.exports = __webpack_public_path__ + "img/zhangzhengxue.eba28bac.jpg";